import { Alert, Box, Button, Card, CardContent, CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Build } from "@mui/icons-material";
import { useAgrianIssuesViewModel } from "./AgrianIssues.vm";
import { PortalTooltip } from "../../helpers";

export const AgrianIssues: React.FC = () => {
	const vm = useAgrianIssuesViewModel();

	if (!vm.isDeveloper) {
		return (
			<Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: "md", margin: "auto" }}>
				<Alert severity="error">You do not have permission to access this page.</Alert>
			</Box>
		);
	}

	return (
		<Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: "lg", margin: "auto" }}>
			<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
				<Typography variant="h5">Agrian Issues</Typography>
				<Button
					variant="contained"
					onClick={vm.fixAll}
					disabled={vm.loading || vm.fixingAll || vm.jobs.length === 0}
					startIcon={vm.fixingAll ? <CircularProgress size={20} color="inherit" /> : undefined}
				>
					{vm.fixingAll
						? `Fixing All... ${vm.countdown !== null ? `(${vm.countdown}s)` : ""}`
						: `Fix All (${vm.jobs.length})`}
				</Button>
			</Stack>
			{vm.jobs.length > 0 && (
				<Alert severity="info" sx={{ mb: 2 }}>
					These jobs have no Event ID, meaning they have not been submitted to Agrian.
				</Alert>
			)}

			{vm.error && (
				<Alert severity="error" sx={{ mb: 2 }}>
					{vm.error}
				</Alert>
			)}

			{vm.loading ? (
				<Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
					<CircularProgress />
				</Box>
			) : vm.jobs.length === 0 ? (
				<Alert severity="success">No Agrian issues found.</Alert>
			) : (
				<Grid container spacing={2}>
					{vm.jobs.map((job) => {
						const isFixing = vm.fixingIds.has(job.id);
						return (
							<Grid key={job.id} size={{ xs: 12, sm: 6, md: 4 }}>
								<Card variant="outlined">
									<CardContent>
										<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
											<Box display="grid" gridTemplateColumns="auto 1fr" columnGap={1} rowGap={0.5}>
												<Typography variant="body2" color="text.secondary">
													Grower:
												</Typography>
												<Typography variant="body2">{job.growerName || "—"}</Typography>
												<Typography variant="body2" color="text.secondary">
													Farm:
												</Typography>
												<Typography variant="body2">{job.farmName || "—"}</Typography>
												<Typography variant="body2" color="text.secondary">
													Field:
												</Typography>
												<Typography variant="body2">{job.fieldName || "—"}</Typography>
												<Typography variant="body2" color="text.secondary">
													Status:
												</Typography>
												<Typography variant="body2">{job.status || "—"}</Typography>
												<Typography variant="body2" color="text.secondary">
													Event ID:
												</Typography>
												<Typography variant="body2">{job.eventId || "—"}</Typography>
											</Box>
											{isFixing ? (
												<CircularProgress size={24} />
											) : (
												<PortalTooltip title="Create event ID">
													<IconButton
														size="small"
														onClick={() => vm.fixOne(job.id)}
														disabled={vm.fixingAll}
														color="primary"
													>
														<Build fontSize="small" />
													</IconButton>
												</PortalTooltip>
											)}
										</Box>
									</CardContent>
								</Card>
							</Grid>
						);
					})}
				</Grid>
			)}
		</Box>
	);
};
